<template>
  <div class="sidebar-menu">
    <v-menu
      v-model="menu"
      offset-x
      absolute
      :close-on-content-click="false"
      :position-x="279"
      :position-y="67"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="menu-element" v-bind="attrs" v-on="on" v-on:click="handleClick">
          <div class="menu-element-icon">
            <Icon type="clock" size="20" />
          </div>
          <div class="menu-element-title grey-900">{{ $t('Catch up') }}</div>
          <Badge v-if="!!count">
            {{ count }}
          </Badge>
        </div>
      </template>
      <CatchUpModal :unread-count="count" />
    </v-menu>
    <router-link :to="{ name: 'contractors' }" class="menu-element">
      <div class="menu-element-icon">
        <Icon type="folder" size="20" />
      </div>
      <div class="menu-element-title grey-900">{{ $t('Contractors') }}</div>
    </router-link>
  </div>
</template>

<script>
  import Badge from '@/components/ui/Badge';
  import notificationsCount from '@/gql/catch-up/notifications-count.graphql';
  import CatchUpModal from '@/containers/catch-up/CatchUpModal';
  import { VMenu } from 'vuetify/lib';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'Menu',
    components: {
      Badge,
      VMenu,
      CatchUpModal,
      Icon,
    },
    data() {
      return {
        count: 0,
        menu: false,
      };
    },
    apollo: {
      $subscribe: {
        notificationsCount() {
          return {
            query: notificationsCount,
            result({ data }) {
              this.count = data?.notification_aggregate?.aggregate?.count || 0;
            },
          };
        },
      },
    },
    methods: {
      handleClick() {
        document.body.dispatchEvent(new Event('click'));
      },
    },
  };
</script>

<style lang="scss" scoped>
  .catch-up-modal {
    margin-left: 50px;
  }
</style>
